const PLACEHOLDER_EMAIL_DOMAIN = 'phone.myorderid';
/** Map E.164 phone to a unique placeholder email for phone-only accounts. */
export const phoneToPlaceholderEmail = (phoneNumber: string) => {
	const digits = phoneNumber.replace(/\D/g, '');
	return `${digits}@${PLACEHOLDER_EMAIL_DOMAIN}`;
};

export const isPlaceholderEmail = (email: string) => {
	return email.endsWith(`@${PLACEHOLDER_EMAIL_DOMAIN}`);
};

export const placeholderEmailToPhone = (email: string) => {
	return `+${email.split(`@${PLACEHOLDER_EMAIL_DOMAIN}`)[0]}`;
};